import { useRecipesHook } from "../../../Hooks/communicators/useRecipesHook";
import { useSettingsHook } from "../../../Hooks/communicators/useSettingsHook";

export default function SettingsSelector() {
    const {
        selectedSettingsPage,
        changeSelectedSettingsPage,
    } = useSettingsHook();

    return (
        <div className='my-8 flex justify-center items-center flex-col'>
            <p className='text-2xl font-normal mb-4'>Project Settings</p>
            <p className='text-lg font-light mb-4'>Manage Project Settings</p>
            <div className='flex justify-between items-center my-4'>
                <div className='flex justify-end items-center'>
                    <button
                        onClick={() => changeSelectedSettingsPage(1)}
                        className='bg-blue-400 text-white p-2 rounded-md ml-4 transition ease-in-out delay-75 hover:scale-110 hover:transition-all hover:ease-in-out'>
                        Configs
                    </button>
                    <button
                        onClick={() => changeSelectedSettingsPage(2)}
                        className='bg-blue-400 text-white p-2 rounded-md ml-4 transition ease-in-out delay-75 hover:scale-110 hover:transition-all hover:ease-in-out'>
                        Onboarding
                    </button>
                    <button
                        onClick={() => changeSelectedSettingsPage(3)}
                        className='bg-blue-400 text-white p-2 rounded-md ml-4 transition ease-in-out delay-75 hover:scale-110 hover:transition-all hover:ease-in-out'>
                        Terms and Conditions
                    </button>
                    <button
                        onClick={() => changeSelectedSettingsPage(4)}
                        className='bg-blue-400 text-white p-2 rounded-md ml-4 transition ease-in-out delay-75 hover:scale-110 hover:transition-all hover:ease-in-out'>
                        Meet with Dietitian
                    </button>
                </div>
            </div>
        </div>
    )
}
